import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import AddTeamComponent from '../components/AddTeamComponent'

const mapStateToProps = (state) => {
  return {
    team: state.team,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTeamComponent)
